import React, { Component } from "react";
import Helmet from "react-helmet";
// import config from "../../../data/SiteConfig";

// See https://raw.githubusercontent.com/Vagr9K/gatsby-material-starter/master/src/components/SEO/SEO.jsx
/**
 * Simply embed in page and pass props
 */
class SeoComponent extends Component {
  render() {
    const { title, description } = this.props
    return (
      <Helmet>
        <title>{title}</title>

        {/* General tags */}
        <meta name="description" content={description} />
        {/* <meta name="image" content={image} /> */}

        {/* Schema.org tags */}
        {/* <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script> */}

        {/* OpenGraph tags */}
        {/* <meta property="og:url" content={postSEO ? postURL : blogURL} /> */}
        {/* {postSEO ? <meta property="og:type" content="article" /> : null} */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {/* <meta property="og:image" content={image} /> */}
        {/* <meta
          property="fb:app_id"
          content={config.siteFBAppID ? config.siteFBAppID : ""}
        /> */}

        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        {/* <meta
          name="twitter:creator"
          content={config.userTwitter ? config.userTwitter : ""}
        /> */}
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {/* <meta name="twitter:image" content={image} /> */}
      </Helmet>
    )
  }
}

export default SeoComponent



// WEBPACK FOOTER //
// ./src/components/SeoComponent/index.js